import { render, staticRenderFns } from "./ReminderLayoutEdit.vue?vue&type=template&id=42bcd754"
import script from "./ReminderLayoutEdit.vue?vue&type=script&lang=ts"
export * from "./ReminderLayoutEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42bcd754')) {
      api.createRecord('42bcd754', component.options)
    } else {
      api.reload('42bcd754', component.options)
    }
    module.hot.accept("./ReminderLayoutEdit.vue?vue&type=template&id=42bcd754", function () {
      api.rerender('42bcd754', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/default/ReminderLayoutEdit.vue"
export default component.exports